import type { Endpoints } from '../../../directus/extensions/gogigi/src/promoter-endpoint/types.ts';
import { env } from '../env.ts';
import { getAuthHeaders } from './directusClient/directusClient.ts';

const baseUrl = `${env.VITE_DIRECTUS_API_URL}/promoter`;

const readJsonBody = async (response: Response): Promise<unknown> => {
  try {
    return (await response.json()) as unknown;
  } catch {
    return { type: 'UNKNOWN_ERROR', message: response.statusText };
  }
};

/** Error bodies carry a `type`; the success shapes come from the extension's `Endpoints` types. */
const handleResponse = async <T>(response: Response): Promise<T> => {
  const data = await readJsonBody(response);

  if (!response.ok && !(typeof data === 'object' && data !== null && 'type' in data)) {
    throw new Error(response.statusText);
  }

  return data as T;
};

export const publishEvent = async (
  incompleteEventId: string,
): Promise<Endpoints['POST /publish-event/:id']['Response']> => {
  const response = await fetch(`${baseUrl}/publish-event/${incompleteEventId}`, {
    method: 'POST',
    headers: await getAuthHeaders(),
  });

  return handleResponse(response);
};

export const resubmitEvent = async (eventId: string): Promise<Endpoints['POST /resubmit-event/:id']['Response']> => {
  const response = await fetch(`${baseUrl}/resubmit-event/${eventId}`, {
    method: 'POST',
    headers: await getAuthHeaders(),
  });

  return handleResponse(response);
};

export const completeOnboarding = async (): Promise<Endpoints['POST /onboarding-complete']['Response']> => {
  const response = await fetch(`${baseUrl}/onboarding-complete`, {
    method: 'POST',
    headers: await getAuthHeaders(),
  });

  return handleResponse(response);
};
